window.onload = function () {

  /* show / hide main nav
  -------------------------------------------------- */
  const container = document.querySelector("#left-navigation");
  const trigger = document.querySelector("#left-navigation .trigger");
  const body = document.querySelector("body");

  if (container && trigger) {

    // Toggle left navigation
    trigger.addEventListener("click", (event) => {
      // Toggle menu to visible
      container.classList.toggle("show");

      // Toggle burger icon
      trigger.classList.toggle("icon-close");
      trigger.classList.toggle("icon-menu");

      // Don´t trigger the outside click detection
      event.stopPropagation();
    }); 

    // Close on click outside
    const html = document.querySelector("html");
    html.addEventListener("click", (event) => {
      if (container.classList.contains("show") && !event.target.tagName.toUpperCase() == 'INPUT') {
        container.classList.remove("show");

        trigger.classList.toggle("icon-close");
        trigger.classList.toggle("icon-menu");
      }
    });
  }
};
